import { render } from "./DocumentLocatorTestingForm.vue?vue&type=template&id=33bc412a&scoped=true&ts=true"
import script from "./DocumentLocatorTestingForm.vue?vue&type=script&lang=ts"
export * from "./DocumentLocatorTestingForm.vue?vue&type=script&lang=ts"

import "./DocumentLocatorTestingForm.vue?vue&type=style&index=0&id=33bc412a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc412a"]])

export default __exports__